import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { StaffMember } from 'frontend/types/about';

interface AboutPageState {
  staff_members: StaffMember[];
}

const staffMembers: Module<AboutPageState, RootState> = {
  namespaced: true,
  state: {
    staff_members: [] as StaffMember[],
  } as AboutPageState,
  getters: {},
  mutations: {
    setValue(state: AboutPageState, value: StaffMember[]): void {
      state.staff_members = value;
    },
  },
  actions: {},
};

export default staffMembers;
